import { render } from "./Avatar.vue?vue&type=template&id=04aca002"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"
script.render = render

export default script